import {
  BaseSourceSiteWorkCentre,
  useSettingsContext,
} from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { BaseTable } from 'Features/Projects/Table/BaseTable.view'
import { Box } from '@mui/material'
import {
  useUpdateBaseSourceSiteWorkCentre,
  useUploadBaseSourceSiteWorkcentre,
} from '../EditSettings.data'
import { toast } from 'react-hot-toast'

interface CapacitiesTableProps {
  data: BaseSourceSiteWorkCentre[]
  isLoading: boolean
}
const onSuccess = () => {
  toast.success('Update Succesful')
}

const onError = () => {
  toast.error('Update Failed')
}
export const CapacitiesTable = ({ data, isLoading }: CapacitiesTableProps) => {
  const COLUMN_WIDTH = 150

  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state
  const { mutate, isLoading: isSaving } = useUpdateBaseSourceSiteWorkCentre(
    onSuccess,
    onError
  )
  const onUploadSuccess = () => {
    toast.success('Upload Successful')
  }
  const onUploadError = () => {
    toast.error('Upload Failed')
  }
  const { mutate: uploadMutate, isPending: isUploading } =
    useUploadBaseSourceSiteWorkcentre(onUploadSuccess, onUploadError)

  const updateTableData = (
    changedRows: Record<string, BaseSourceSiteWorkCentre>
  ) => {
    mutate({
      changedRows,
      projectId,
      scenarioId,
    })
  }

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'baseSourceSiteCode',
        headerName: 'Base Source Site Code',
        width: COLUMN_WIDTH,
        type: 'string',
        flex: 1,
        pinned: true,
      },
      {
        field: 'workcentreCode',
        headerName: 'Work Centre Code',
        width: COLUMN_WIDTH,
        type: 'string',
        flex: 1,
        pinned: true,
      },
      {
        field: 'workcentreCapacity',
        headerName: 'Work Centre Capacity',
        width: COLUMN_WIDTH,
        type: 'number',
        editable: true,
        flex: 1,
        valueFormatter: (value: number) => {
          if (value === null || value === undefined) return ''
          return value.toFixed(1)
        },
      },
      {
        field: 'headSpaceBuffer',
        headerName: 'Head Space Buffer',
        width: COLUMN_WIDTH,
        type: 'number',
        editable: true,
        flex: 1,
        valueFormatter: (value: number) => {
          if (value === null || value === undefined) return ''
          return `${value.toFixed(1)}%`
        },
      },
    ]
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        overflow: 'auto',
        flexDirection: 'column',
      }}
    >
      <BaseTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={(file: File) => {
          uploadMutate({ file, projectId, scenarioId })
        }}
        isUploading={isUploading ?? false}
        isSaving={isSaving}
        checkBoxSelection={true}
        pinnedColumns={['baseSourceSiteCode', 'workcentreCode']}
        customDownloadDataMethod={(tableData) => tableData}
      />
    </Box>
  )
}
